<div class="modal-header refer-modal-header">
  <h4 class="modal-title text-center">{{ 'popup.ref_link' | translate }}</h4>
      <svg-icon src="/assets/images/svg-icons/close-black.svg" [svgStyle]="{ 'width.px': 14, 'height.px': 14 }" class="cursor-pointer" (click)="modalRef.hide()"></svg-icon>
</div>
<div class="modal-body">
  <!-- <div class="fw-medium font-16 text-center">{{ 'popup.ref_text' | translate }}</div> -->
  <div class="amountField d-flex flex-column align-items-start">
    <label for="evmAddress">EVM Address</label>
    <input [(ngModel)]="evmWalletAddress" id="evmAddress" placeholder="Please enter your EVM address" type="text" />
  </div>
  <div class="amountField d-flex flex-column align-items-start">
    <label for="solAddress">SOL Address</label>
    <input [(ngModel)]="solWalletAddress" id="solAddress" placeholder="Please enter your SOL address" type="text" />
  </div>

  <!-- <button type="button" class="btn btn-outline-primary my-3 d-block refer-btn wx-250 mx-auto" (click)="copy()" ngxClipboard [cbContent]="url">
    <div class="d-flex align-items-center justify-content-center">
      <span class="d-inline-block text-truncate font-13">{{ url }}</span>
      <svg-icon src="./assets/images/svg-icons/copy.svg" [svgStyle]="{ 'width.px': 20, 'height.px': 20 }" class=""></svg-icon>
    </div>
  </button> -->

  <div class="footer">
    <button type="button" class="btn btn-outline-primary w-100 mt-3 icon-btn d-block" (click)="submitAddresses()">{{ 'misc.copy_refer_url' | translate }}</button>
  </div>
</div>
